module.exports = __webpack_public_path__ + "static/commandbar-f57cdee5c792a207f37137707de27758.png";